import { useEffect, useState, useRef, useLayoutEffect } from "react";
import './FilterDropdown.css';

function FilterDropdown({ title, value, options, onChange, icon, isIconMode }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [listStyle, setListStyle] = useState({});

    // إغلاق القائمة عند النقر خارجها
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useLayoutEffect(() => {
        if (isOpen && isIconMode && dropdownRef.current) {
            const rect = dropdownRef.current.getBoundingClientRect();
            
            // تحديد الـ right ليتجاوز السايدبار (عرض السايدبار في وضع الأيقونات هو 50px)
            // بما أن القائمة ستكون fixed، نعتمد على الإحداثيات مباشرة
            setListStyle({
                position: 'fixed',
                top: rect.top, 
                right: 60 + 'px', 
                width: '200px', 
                zIndex: 1000,
                maxHeight: window.innerHeight - rect.top - 100,
            });
        } else if (!isIconMode) {
            // إذا لم يكن وضع الأيقونات، نستخدم التنسيقات الافتراضية (CSS)
            setListStyle({});
        }
    }, [isOpen, isIconMode]);

    const selectedOption = options.find(opt => opt.value === value) || { label: `الكُل`, value: "" };

    const handleHeaderClick = (e) => {
        // إذا كنا في وضع الأيقونات، نمنع إغلاق السايدبار بالكامل (إذا كان هناك منطق لذلك)
        e.stopPropagation(); 
        setIsOpen(!isOpen);
    };

    return (
        <div className={`custom_dropdown_container ${isIconMode ? 'icon-mode' : ''}`} ref={dropdownRef}>
            <div className="dropdown_header" onClick={handleHeaderClick}>
                <div className="header_title">
                    {icon}
                    <span>{title}</span>
                </div>
                {/* عرض القيمة المختارة أو "الكل" */}
                <span className="selected_value">
                    {selectedOption.label.length > 15 ? selectedOption.label.substring(0, 15) + '...' : selectedOption.label}
                </span>
            </div>
            {isOpen && (
                <ul className={`dropdown_list ${isIconMode ? 'fixed-list' : ''}`}
                style={isIconMode ? listStyle : {}}>
                    <li 
                        onClick={() => {
                            onChange("");
                            setIsOpen(false);
                        }}
                        className={value === "" ? 'selected' : ''}
                    >
                        الكُل
                    </li>
                    {options.map((option, index) => (
                        <li 
                            key={index} 
                            onClick={() => {
                                onChange(option.value);
                                setIsOpen(false);
                            }}
                            className={value === option.value ? 'selected' : ''}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default FilterDropdown